(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('custactGantt', {
        templateUrl: 'views/components/views/custactGantt/custactGantt.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'utilityService', 'ieScreenBlockService', 'custactGanttService', function ($stateParams, utilityService, ieScreenBlockService, custactGanttService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let connectTo = $stateParams.connectto;
            let connectToValue = $stateParams.connectto_value;

            vm.ganttReady = false;
            vm.setting = {};

            vm.searchTextButtons = [
                { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') },
                { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => loadGantts() }
            ];

            vm.ganttTasks = {
                custact_no: '',
                custact_no_belongto: '',
                datetime_start: '',
                datetime_end: '',
                note: '',
                ok: '',
                orderby: '',
                summary: '',
                complete_pst: '',
                records: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.setting = (await custactGanttService.getSetting({
                    connectto: connectTo,
                    connectto_value: connectToValue
                }))[0];

                return loadGantts();
            }

            async function loadGantts() {
                if (utilityService.validateParmsValue(vm.setting.searchtext, true) !== true) return;

                ieScreenBlockService.start('message');
                ieScreenBlockService.setMessage(vm.setting.retrieve_message); 
                
                vm.ganttReady = false;

                const data = await custactGanttService.listGantts(vm.setting);

                vm.ganttTasks.records.length = 0;
                vm.ganttTasks.records = [...data];

                ieScreenBlockService.stop(); 
                vm.ganttReady = true;
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region MULTI CLEAR FUNCTION

            function clear(id) {
                switch (id) {
                    case 'searchtext':
                        vm.setting.searchtext = '';

                        if (vm.setting.searchtext === '') loadGantts();
                        break;
                    default:
                        break;
                }
            }

            // #endregion MULTI CLEAR FUNCTION

            // #region SUBMIT SEARCH FUNCTION

            vm.submitSearch = function () {
                loadGantts();
            }

            // #endregion SUBMIT SEARCH FUNCTION

            // #region UPDATE INFO FUNCTION

            vm.updateInfo = function () {
                custactGanttService.saveGantt({ gantt_list: vm.ganttTasks.records[0].custacts });
            }

            // #endregion UPDATE INFO FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'searchtext':
                        if (utilityService.validateWatchValue(value, vm.setting.searchtext) !== true) return;

                        vm.setting.searchtext = value;

                        if (utilityService.validateParmsValue(vm.setting.searchtext, true) !== true) return;

                        if (vm.setting.searchtext === '') loadGantts();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                await loadSetting();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
